import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/')({
    component: AdminLanding,
});

function AdminLanding() {
    return <Navigate to="/admin/agent" replace={true} />;
}
